<template>
    <modal @close="$emit('close')" :autoshow="true" ref="modal" :is-closeable="isCloseable">
        <template v-slot:title>Edit Employee Address</template>

        <template v-slot:subheading>
            <div class="p-1 unpad-x bg-150 rounded">
                <div><span class="text-muted">Employee:</span> {{ employee.full_name }}</div>
                <div><span class="text-muted">Company:</span> {{ employee.company.name }}</div>
            </div>
        </template>

        <slot>
            <div>
                <form-errors :errors="formErrors"/>

                <!-- Resident address -->
                <form v-if="addressMode == 'resident'">
                    <h4 class="mt-2 mb-2">Resident Address</h4>
                    <form-input label="Address 1" v-model="formData.address_1" :errors="errors.address_1" type="text" :maxlength="50"/>
                    <form-input label="Address 2 (Optional)" v-model="formData.address_2" :errors="errors.address_2" type="text" :maxlength="50"/>
                    <form-input label="City" v-model="formData.city" :errors="errors.city" type="text" :maxlength="50"/>
                    <div class="form-row">
                        <div class="col-6">
                            <form-input label="State" v-model="formData.state" :errors="errors.state" type="select" :options="stateOptions"/>
                        </div>

                        <div class="col-6">
                            <form-input label="Zip Code" :maxlength="5" v-model="formData.postal_code" :errors="errors.postal_code" type="text" />
                        </div>
                    </div>
                </form>
                <!-- Optional Mailing address -->
                <form v-if="addressMode == 'mailing'">
                    <form-input label="Use a different mailing address?" type="checkbox" v-model="formData.use_mailing_address" class="mb-2"/>

                    <template v-if="formData.use_mailing_address">
                        <h4 class="mt-2 mb-2">Mailing Address</h4>
                        <form-input label="Address 1" v-model="formData.mailing_address_1" :errors="errors.mailing_address_1" type="text" :maxlength="50"/>
                        <form-input label="Address 2 (Optional)" v-model="formData.mailing_address_2" :errors="errors.mailing_address_2" type="text" :maxlength="50"/>
                        <form-input label="City" v-model="formData.mailing_city" :errors="errors.mailing_city" type="text" :maxlength="50"/>
                        <div class="form-row">
                            <div class="col-6">
                                <form-input label="State" v-model="formData.mailing_state" :errors="errors.mailing_state" type="select" :options="stateOptions"/>
                            </div>

                            <div class="col-6">
                                <form-input label="Zip Code" :maxlength="5" v-model="formData.mailing_postal_code" :errors="errors.mailing_postal_code" type="text" />
                            </div>
                        </div>
                    </template>
                </form>
            </div>
        </slot>

        <template v-slot:footer>
            <div class="form-row">
                <div class="col">
                    <button type="button" class="btn btn-block btn-outline-primary" @click.prevent="close()">Cancel</button>
                </div>
                <div class="col">
                    <button type="submit" class="btn btn-block btn-primary" @click.prevent="onSubmit">Save</button>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import states from '@/states'
import ModalMixin from '@/mixins/ModalMixin'
import FormMixin from '@/mixins/Form'

export default {
    mixins: [ModalMixin, FormMixin],
    components: {},
    props: ['client', 'employee', 'addressMode'],
    data() {
        return {
            formData: this.makeFormData(),
        }
    },
    computed: {
        stateOptions() {
            const result = []
            states.forEach((s) => {
                result.push({text: s.name.toUpperCase(), value: s.abbreviation})
            })
            return result
        },
    },
    methods: {
        makeFormData() {
            if (this.addressMode == 'mailing') {
                return {
                    use_mailing_address: this.employee.use_mailing_address,
                    mailing_address_1: this.employee.mailing_address_1,
                    mailing_address_2: this.employee.mailing_address_2,
                    mailing_city: this.employee.mailing_city,
                    mailing_state: this.employee.mailing_state,
                    mailing_postal_code: this.employee.mailing_postal_code,
                }
            } else if (this.addressMode == 'resident') {
                return {
                    address_1: this.employee.address_1,
                    address_2: this.employee.address_2,
                    city: this.employee.city,
                    state: this.employee.state,
                    postal_code: this.employee.postal_code,
                }
            }
        },
        onSubmit() {
            this.errors = {}
            this.formErrors = []
            if (this.addressMode == 'mailing') {
                this.$api.patch(`/clients/${this.client.id}/employees/${this.employee.id}/mailing-address`, this.getFormData()).then(resp => {
                    this.$emit('updated')
                    this.close()
                }).catch(errors => {
                    this.errors = errors
                    this.formErrors = errors.__all__
                })
            } else if (this.addressMode == 'resident') {
                this.$api.patch(`/clients/${this.client.id}/employees/${this.employee.id}/resident-address`, this.getFormData()).then(resp => {
                    this.$emit('updated')
                    this.close()
                }).catch(errors => {
                    this.errors = errors
                    this.formErrors = errors.__all__
                })
            }
        },
    }
}
</script>
